'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _constant = require('./constant');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  data: {},
  cards: [],
  sending: false,
  reviewing: false,
  updating: false,
  // rescheduling: false,
  // responding: false,
  messages: [],
  loadingData: false,
  loadingMessage: false,
  creating: false,
  makingPayment: false,
  paymentErrorMessage: '',
  openDetail: false,
  openCalendar: false,
  openSuggested: false,
  openSwapLX: false,
  suggestedTrips: [],
  suggestedRequesting: false,
  swapLXRequesting: false,
  swapLXRequested: false,
  // confirming: false,
  isOpenConfirmCollide: false,
  settingMeetingPoint: false,
  collideTripsCount: 0,
  quickLX: {
    step: '',
    lxCanceling: false
  },
  isOpenHotelPickupLX: false,
  acceptingHotelPickupLX: false,
  isOpenStreetFoodLX: false,
  acceptingStreetFoodLX: false,
  isOpenProposeNewDateModal: false,
  processingWorryFreeBookingNotification: false,
  notifyWorryFreeBookingSuccessfully: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _constant.CLEAR_LOADING_DATA:
      return (0, _extends3.default)({}, state, {
        loadingData: false
      });
    case _constant.CREATE_BOOKING:
      return (0, _extends3.default)({}, state, {
        creating: true
      });
    case _constant.CREATE_BOOKING_SUCCESS:
      return (0, _extends3.default)({}, state, {
        creating: false
      });
    case _constant.CREATE_BOOKING_FAIL:
      return (0, _extends3.default)({}, state, {
        creating: false
      });
    // case CONFIRM_BOOKING:
    //   return {
    //     ...state,
    //     confirming: true,
    //   };
    case _constant.CHECK_CANCEL_SUCCESS:
      return (0, _extends3.default)({}, state, {
        collideTripsCount: action.result.total
      });
    case _constant.OPEN_COLLIDE:
      return (0, _extends3.default)({}, state, {
        isOpenConfirmCollide: action.open
      });
    case _constant.GET_BOOKING_DATA:
      return (0, _extends3.default)({}, state, {
        loadingData: true
      });
    case _constant.GET_BOOKING_DATA_SUCCESS:
      return (0, _extends3.default)({}, state, {
        data: action.result,
        loadingData: false
      });
    case _constant.GET_BOOKING_DATA_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingData: false
      });
    case _constant.GET_MESSAGES:
      return (0, _extends3.default)({}, state, {
        loadingMessage: true
      });
    case _constant.GET_MESSAGES_SUCCESS:
      return (0, _extends3.default)({}, state, {
        messages: action.result,
        loadingMessage: false
      });
    case _constant.GET_MESSAGES_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingMessage: false
      });
    case _constant.LOAD_SUGGESTED_TRIP_SUCCESS:
      return (0, _extends3.default)({}, state, {
        suggestedTrips: action.result,
        openSuggested: action.result.length > 0 ? true : false
      });
    case _constant.OPEN_SUGGESTED:
      return (0, _extends3.default)({}, state, {
        openSuggested: action.active
      });
    case _constant.OPEN_SWAP_LX:
      return (0, _extends3.default)({}, state, {
        openSwapLX: action.active
      });
    case _constant.OPEN_CALENDAR:
      return (0, _extends3.default)({}, state, {
        openCalendar: action.active
      });
    case _constant.OPEN_DETAIL:
      return (0, _extends3.default)({}, state, {
        openDetail: action.active
      });
    case _constant.POST_REVIEW:
    case _constant.POST_EXTRA_REVIEW:
      return (0, _extends3.default)({}, state, {
        reviewing: true
      });
    case _constant.POST_REVIEW_SUCCESS:
    case _constant.POST_REVIEW_FAIL:
    case _constant.POST_EXTRA_REVIEW_SUCCESS:
    case _constant.POST_EXTRA_REVIEW_FAIL:
      return (0, _extends3.default)({}, state, {
        reviewing: false
      });
    case _constant.REPLY_REVIEW:
      return (0, _extends3.default)({}, state, {
        replying: true
      });
    case _constant.REPLY_REVIEW_SUCCESS:
      return (0, _extends3.default)({}, state, {
        replying: false
      });
    case _constant.REPLY_REVIEW_FAIL:
      return (0, _extends3.default)({}, state, {
        replying: false
      });
    // case SET_BOOKING_DATA:
    //   return {
    //     ...state,
    //     data: action.data,
    //   };
    // case RESCHEDULE_BOOKING:
    //   return {
    //     ...state,
    //     rescheduling: true
    //   };
    // case RESCHEDULE_BOOKING_SUCCESS:
    // case RESCHEDULE_BOOKING_FAIL:
    //   return {
    //     ...state,
    //     rescheduling: false
    //   };
    // case RESPOND_BOOKING:
    //   return {
    //     ...state,
    //     responding: true,
    //   };
    // case RESPOND_BOOKING_SUCCESS:
    // case RESPOND_BOOKING_FAIL:
    //   return {
    //     ...state,
    //     responding: false,
    //   };
    case _constant.REQUEST_SUGGESTED_TRIP:
      return (0, _extends3.default)({}, state, {
        suggestedRequesting: true
      });
    case _constant.REQUEST_SUGGESTED_TRIP_SUCCESS:
      return (0, _extends3.default)({}, state, {
        suggestedRequesting: false,
        openSuggested: false
      });
    case _constant.REQUEST_SUGGESTED_TRIP_FAIL:
      return (0, _extends3.default)({}, state, {
        suggestedRequesting: false
      });
    case _constant.REQUEST_SWAP_LX:
      return (0, _extends3.default)({}, state, {
        swapLXRequesting: true
      });
    case _constant.REQUEST_SWAP_LX_SUCCESS:
    case _constant.REQUEST_SWAP_LX_FAIL:
      return (0, _extends3.default)({}, state, {
        swapLXRequesting: false,
        swapLXRequested: true
      });
    case _constant.SET_SWAP_REQUESTED:
      return (0, _extends3.default)({}, state, {
        swapLXRequested: action.requested
      });
    // case SET_MEETING_POINT:
    //   return {
    //     ...state,
    //     settingMeetingPoint: true,
    //   };
    // case SET_MEETING_POINT_SUCCESS:
    // case SET_MEETING_POINT_FAIL:
    //   return {
    //     ...state,
    //     settingMeetingPoint: false,
    //   };
    case _constant.SEND_MESSAGE:
      return (0, _extends3.default)({}, state, {
        sending: true
      });
    case _constant.SEND_MESSAGE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        sending: false,
        messages: [action.result].concat((0, _toConsumableArray3.default)(state.messages))
      });
    case _constant.SEND_MESSAGE_FAIL:
      return (0, _extends3.default)({}, state, {
        sending: false
      });
    case _constant.ACTIVATE_BOOKING:
      return (0, _extends3.default)({}, state, {
        sending: true
      });
    case _constant.ACTIVATE_BOOKING_SUCCESS:
    case _constant.ACTIVATE_BOOKING_FAIL:
      return (0, _extends3.default)({}, state, {
        sending: false
      });
    case _constant.UPDATE_BOOKING:
    case _constant.CONFIRM_BOOKING:
    case _constant.RESCHEDULE_BOOKING:
    case _constant.RESPOND_BOOKING:
    case _constant.SET_MEETING_POINT:
    case _constant.SUBMIT_LX_CANCEL:
    case _constant.SUBMIT_PAYMENT_CODE:
    case _constant.UPLOAD_TRIP_IMAGE:
    case _constant.HOLD_PAYMENT:
      return (0, _extends3.default)({}, state, {
        updating: true
      });
    case _constant.UPDATE_BOOKING_SUCCESS:
      return (0, _extends3.default)({}, state, {
        updating: false
      });
    case _constant.CONFIRM_BOOKING_SUCCESS:
    case _constant.RESCHEDULE_BOOKING_SUCCESS:
    case _constant.RESPOND_BOOKING_SUCCESS:
    case _constant.SET_MEETING_POINT_SUCCESS:
    case _constant.SUBMIT_LX_CANCEL_SUCCESS:
    case _constant.SUBMIT_PAYMENT_CODE_SUCCESS:
    case _constant.UPLOAD_TRIP_IMAGE_SUCCESS:
    case _constant.HOLD_PAYMENT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        updating: false,
        data: action.result[0],
        messages: action.result[1]
      });
    case _constant.CONFIRM_BOOKING_FAIL:
    case _constant.UPDATE_BOOKING_FAIL:
    case _constant.RESCHEDULE_BOOKING_FAIL:
    case _constant.RESPOND_BOOKING_FAIL:
    case _constant.SET_MEETING_POINT_FAIL:
    case _constant.SUBMIT_LX_CANCEL_FAIL:
    case _constant.SUBMIT_PAYMENT_CODE_FAIL:
    case _constant.UPLOAD_TRIP_IMAGE_FAIL:
    case _constant.HOLD_PAYMENT_FAIL:
      return (0, _extends3.default)({}, state, {
        updating: false
      });
    case _constant.PUSH_MESSAGE:
      return (0, _extends3.default)({}, state, {
        messages: [action.msg].concat((0, _toConsumableArray3.default)(state.messages))
      });
    case _constant.SET_NEWBOOKING:
      return (0, _extends3.default)({}, state, {
        data: action.newBooking
      });
    case _constant.SET_MESSAGE:
      return (0, _extends3.default)({}, state, {
        messages: state.messages.reduce(function (prev, current) {
          if (current._id === action.newMessage._id) {
            current.is_censored = action.newMessage.is_censored;
            current.text = action.newMessage.text;
          }
          prev.push(current);
          return prev;
        }, [])
      });
    case _constant.CHANGE_STEP:
      return (0, _extends3.default)({}, state, {
        quickLX: (0, _extends3.default)({}, state.quickLX, { step: action.step })
      });
    case _constant.OPEN_LX_HOTEL_PICKUP:
      return (0, _extends3.default)({}, state, {
        isOpenHotelPickupLX: true
      });
    case _constant.CLOSE_LX_HOTEL_PICKUP:
      return (0, _extends3.default)({}, state, {
        isOpenHotelPickupLX: false
      });
    // case SUBMIT_LX_CANCEL:
    //   return {
    //     ...state,
    //     quickLX: {...state.quickLX, lxCanceling: true},
    //   };
    // case SUBMIT_LX_CANCEL_SUCCESS:
    // case SUBMIT_LX_CANCEL_FAIL:
    //   return {
    //     ...state,
    //     quickLX: {...state.quickLX, lxCanceling: false},
    //   };
    case _constant.LX_ACCEPT_HOTEL_PICKUP:
      return (0, _extends3.default)({}, state, {
        acceptingHotelPickupLX: true
      });
    case _constant.LX_ACCEPT_HOTEL_PICKUP_SUCCESS:
    case _constant.LX_ACCEPT_HOTEL_PICKUP_FAIL:
      return (0, _extends3.default)({}, state, {
        acceptingHotelPickupLX: false
      });
    case _constant.OPEN_LX_STREET_FOOD:
      return (0, _extends3.default)({}, state, {
        isOpenStreetFoodLX: true
      });
    case _constant.CLOSE_LX_STREET_FOOD:
      return (0, _extends3.default)({}, state, {
        isOpenStreetFoodLX: false
      });
    case _constant.LX_ACCEPT_STREET_FOOD:
      return (0, _extends3.default)({}, state, {
        acceptingStreetFoodLX: true
      });
    case _constant.LX_ACCEPT_STREET_FOOD_SUCCESS:
    case _constant.LX_ACCEPT_STREET_FOOD_FAIL:
      return (0, _extends3.default)({}, state, {
        acceptingStreetFoodLX: false
      });
    case _constant.LX_OPEN_PROPOSE_NEW_DATE_MODAL:
      return (0, _extends3.default)({}, state, {
        isOpenProposeNewDateModal: true
      });
    case _constant.LX_CLOSE_PROPOSE_NEW_DATE_MODAL:
      return (0, _extends3.default)({}, state, {
        isOpenProposeNewDateModal: false
      });
    case _constant.NOTIFY_WORRY_FREE_BOOKING:
      return (0, _extends3.default)({}, state, {
        processingWorryFreeBookingNotification: true
      });
    case _constant.NOTIFY_WORRY_FREE_BOOKING_SUCCESS:
      return (0, _extends3.default)({}, state, {
        processingWorryFreeBookingNotification: false,
        notifyWorryFreeBookingSuccessfully: true
      });
    case _constant.NOTIFY_WORRY_FREE_BOOKING_FAIL:
      return (0, _extends3.default)({}, state, {
        processingWorryFreeBookingNotification: false,
        notifyWorryFreeBookingSuccessfully: false
      });
    default:
      return state;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/booking/booking.js
// module id = 1702
// module chunks = 47